// TSP API service functions
import axios from 'axios';
import { 
  TSP_SOLVE_API, 
  TSP_ALGORITHMS_API,
  DELETE_PATH_API
} from '../../../../config';

// Solve TSP using backend API
export const solveTsp = async (groupId, locations, startId = null, algorithm = "nearest_neighbor") => {
  try {
    // Ensure each object in locations array matches backend Location model format
    // Map frontend latitude/longitude to backend expected lat/lng
    const formattedLocations = locations.map(loc => ({
      id: loc.id,
      lat: loc.latitude,
      lng: loc.longitude,
      name: loc.name
    }));

    const response = await axios.post(TSP_SOLVE_API, {
      group_id: groupId,
      params: {
        locations: formattedLocations,
        start_id: startId,
        algorithm: algorithm
      }
    });

    if (response.data.success) {
      return {
        path: response.data.data.path,
        distance: response.data.data.distance,
        time: response.data.data.duration,
        algorithm: response.data.data.algorithm || algorithm
      };
    } else {

      throw new Error(response.data.error || 'Error solving TSP');
    }
  } catch (error) {

    throw error;
  }
};

// Get available TSP algorithms
export const getTspAlgorithms = async () => {
  try {
    const response = await axios.get(TSP_ALGORITHMS_API);
    
    if (response.data.success) {
      return response.data.data;
    } else {

      throw new Error(response.data.error || 'Failed to get TSP algorithm information');
    }
  } catch (error) {

    throw error;
  }
};

// Delete path by ID
export const deletePath = async (pathId) => {
  try {
    const response = await axios.delete(DELETE_PATH_API(pathId));
    
    if (response.data.success) {
      return true;
    } else {

      throw new Error(response.data.error || 'Error deleting path');
    }
  } catch (error) {

    throw error;
  }
}; 